import * as React from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

function Badge({ className, ...props }) {
  return <span className={twMerge(clsx("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold", className))} {...props} />;
}

export { Badge };
